'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _label = require('../../WebformElement/styled/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legend = _label2.default.withComponent('legend');

exports.default = (0, _styledComponents2.default)(Legend).withConfig({
  componentId: 's4trzur-0'
})(['width:100%;float:left;padding:0;margin-bottom:calc(', ' / 2);', ' ', ' ', ''], function (p) {
  return p.theme.spacingUnitFieldset;
}, function (p) {
  return p.labelDisplay === 'inline' && '\n    @media (min-width: 768px) {\n      width: ' + p.theme.inlineLabelWidth + ';\n      padding-right: calc(' + p.theme.spacingUnit + ' / 2);\n    }\n  ';
}, function (p) {
  return p.labelDisplay === 'invisible' && '\n    display: none;\n  ';
}, function (p) {
  return p.labelDisplay === 'before' && '\n    display: block;\n    float: none;\n    width: 100%;\n  ';
});